/**
 * Stable CSS class names for E2E — Customer return list.
 */
export const CRT = {
    page: 'customer-return-page',
    accordion: 'customer-return-page__accordion',
    accordionSummary: 'customer-return-page__accordion-summary',
    summaryTable: 'customer-return-page__summary-table',
    accordionDetails: 'customer-return-page__accordion-details',
    collapseLoading: 'customer-return-page__collapse-loading',
    detailContent: 'customer-return-page__detail-content',
    detailCardsGrid: 'customer-return-page__detail-cards-grid',
    detailCard: 'customer-return-page__detail-card',
    detailProductTable: 'customer-return-page__detail-product-table',
    inputAvatarProduct: 'customer-return-input--avatar-product',
    inputIconButtonCopyField: 'customer-return-input--icon-button-copy-field',
    pagination: 'customer-return-page__pagination',
    iconAccordionExpand: 'customer-return-input--icon-accordion-expand',
} as const;

export const crtCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
